import {
  Col,
  Divider,
  PageHeader,
  Row,
  Spin,
  Form as FormInitial,
  message,
  Select,
  Space,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  SelectItem,
  InputNumberItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  DatePickerItem,
  round10Decimals,
  ButtonItem,
  ErrorItem,
  SelectInsumosItem,
} from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import VistaPrevia from "../VistaPrevia/VistaPrevia";
import AgregarLotes from '../../LotesCaducidades/AgregarLotes/AgregarLotes';
import ElegirLotes from '../../LotesCaducidades/ElegirLotes/ElegirLotes';

const { Option } = Select;

class AgregarOrdenDeProduccion extends Component {
  formRef = React.createRef();
  formRefPrimerForm = React.createRef();
  state = {
    loading: false,
    objetoProyectos: null,
    todasProyectos: null,
    todasInsumos: [],
    todasListaDeMateriales: null,
    objetoListaDeMateriales: null,
    listaDeMaterialesId: null,
    cantidadAGenerarMinima: 0,
    objetoInsumos: null,
    modalVistaPrevia: false,
    modalVistaPreviaId: null,
    modalAgregarLotes: false,
    modalAgregarLotesIndex: null,
    modalAgregarLotesLotes: null,
    modalAgregarLotesVehiculo: false,
    modalAgregarLotesInsumoId : null,
  };
  componentDidMount() {
    this.consultarTodo();
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "listasdemateriales/selectListas",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasListaDeMateriales: res.data,
            objetoListaDeMateriales: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre + " - " + value.insumoAGenerar.descripcion}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.setState({ loading: false });
  }
  atras() {
    this.props.history.goBack();
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "produccion/agregarOrdenDeProduccion",
        {
          ...values,
          empresaId: this.props.empresaId,
          listaDeMateriales: true,
          listaDeMaterialesId: this.state.listaDeMaterialesId,
          marbetes: this.state.modalAgregarMarbetesMarbetes,
          lotes: this.state.modalAgregarLotesLotes,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se agrego una orden de producción");
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.setState({
            modalVistaPrevia: true,
            modalVistaPreviaId: res.data.id,
          });
        } else if (res.data.success === 1) {
          message.error(res.data.message);
        } else {
          message.error("Hubo un error y el insumo no se produjo");
        }
      });
  }

  async onFinishPrimerForm(values) {
    const listaDeMateriales = this.state.todasListaDeMateriales.find(
      (valueTodasLM) =>
        valueTodasLM._id.toString() === values.listaDeMaterialesId.toString()
    );
    let insumosAgregarTodos = []
    const nuevaListaBuscarInsumos = [...(Array.isArray(listaDeMateriales?.insumosAUtilizar) ? listaDeMateriales.insumosAUtilizar : []), { insumoId: listaDeMateriales?.insumoAGenerarId }]
    await Promise.all(nuevaListaBuscarInsumos.map(async (insumo) => {

      const responseInsumo = await axios.post("insumos/buscarInsumoVenta", {
        insumoId: insumo.insumoId,
        empresaId: this.props.empresaId
      }, { headers: this.props.headersToken })

      if (responseInsumo.data.success === 2) {
        insumosAgregarTodos.push(responseInsumo.data.insumo)
      } else {
        return {
          error: true
        }
      }

      return {
        insumoId: insumo.insumoId,
        cantidad: insumo.cantidad,
        proyectoId: insumo.proyectoId,
        precioUnitario: insumo.precioUnitario,
        precioUnitarioConImpuestos: insumo.precioUnitarioConImpuestos,
      }
    }))
    await this.setState({
      todasInsumos: insumosAgregarTodos,
    })
    await this.setState({ loading: true, listaDeMaterialesId: values.listaDeMaterialesId, proyectoId: values.proyectoId, cantidadAGenerarMinima: listaDeMateriales.cantidadAGenerar });
    await this.formRef.current.setFieldsValue({
      insumosUtilizados: listaDeMateriales.insumosAUtilizar,
      insumoGeneradoId: listaDeMateriales.insumoAGenerarId,
      cantidadGenerada: listaDeMateriales.cantidadAGenerar,
      proyectoId: values.proyectoId
    });
    await Promise.all(listaDeMateriales.insumosAUtilizar.map(async (valueInsumo, keyInsumo) => {
      return await this.onChangeInsumo(null, keyInsumo, null, true)
    }))
    await this.setState({ loading: false })
  }
  deselectListaDeMateriales() {
    this.setState({ listaDeMaterialesId: null });
  }
  async onChangeInsumo(value, key, insumoEncontrado, primeraVez) {
    let arrayValue = await this.formRef.current.getFieldValue("insumosUtilizados");
    let proyecto = await this.formRef.current.getFieldValue("proyectoId");
    this.setState({ loading: true });
    const insumoId = arrayValue[key].insumoId;
    let insumo
    if (insumoEncontrado) {
      insumo = insumoEncontrado;
      const yaExiste = this.state.todasInsumos.find(i => i._id === insumo._id);
      if (!yaExiste) {
        await this.setState(prev => ({
          todasInsumos: [...prev.todasInsumos, insumo]
        }));
      }
    } else {
      insumo = this.state.todasInsumos.find(
        (valueInsumos) => valueInsumos._id === insumoId
      );
    }
    this.setState({ loading: false });
    if (!insumo && !primeraVez) return;
    await axios
      .post(
        "inventarios/inventarioInsumoProyecto",
        {
          proyectoId: proyecto,
          insumoId: insumoId,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        arrayValue[key].cantidadProyecto = res.data.cantidad;
      });
    this.formRef.current.setFieldsValue({
      insumosUtilizados: arrayValue,
    });
  }
  cerrarVistaPrevia() {
    this.setState({
      modalVistaPrevia: false,
      modalVistaPreviaId: null,
    });
    this.formRef.current.resetFields();
    this.atras();
  }
  onChangeCantidad(value) {
    const listaDeMateriales = this.state.todasListaDeMateriales.find(
      (valueTodasLM) =>
        valueTodasLM._id.toString() === this.state.listaDeMaterialesId.toString()
    );
    const porcentajeDeCantidad = value / listaDeMateriales.cantidadAGenerar
    const nuevosInsumosAGenerar = listaDeMateriales.insumosAUtilizar.map(valueInsumo => {
      return {
        ...valueInsumo,
        cantidad: round10Decimals(valueInsumo.cantidad * porcentajeDeCantidad)
      }
    })
    this.formRef.current.setFieldsValue({ insumosUtilizados: nuevosInsumosAGenerar })
  }
  abrirAgregarLotes(vehiculo, lotes, insumoId) {
    this.setState({
      modalAgregarLotes: true,
      modalAgregarLotesLotes: lotes,
      modalAgregarLotesVehiculo: vehiculo,
      modalAgregarLotesInsumoId : null, 
    });
  }

  cerrarAgregarLotes(value) {
    this.setState({
      modalAgregarLotes: false,
      modalAgregarLotesLotes: value,
      modalAgregarLotesVehiculo: false,
      modalAgregarLotesInsumoId : null, 
    });
  }

  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumosUtilizados')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }
  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Orden de Producción"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            {this.state.listaDeMaterialesId ? (
              <Form
                ref={this.formRef}
                name="agregarOrdenDeProduccion"
                layout
                bottom={
                  <div style={{ display: "flex", justifyContent: "right" }}>
                    <Space>
                      <ButtonItem
                        style={{ display: "block", margin: "0 0 0 auto" }}
                        onClick={() => this.deselectListaDeMateriales()}
                      >
                        Atras
                      </ButtonItem>
                      <ButtonItem
                        type="primary"
                        htmlType="submit"
                        style={{ display: "block", margin: "0 0 0 auto" }}
                      >
                        Producir
                      </ButtonItem>
                    </Space>
                  </div>
                }
                onFinish={this.onFinish.bind(this)}
                onFinishFailed={this.onFinishFailed}
              >
                <Divider
                  style={{ marginBottom: 10, marginTop: 5 }}
                  children="Insumo a Producir"
                />
                <Row>
                  <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                    <FormItem
                      label="Insumo a Generar"
                      name="insumoGeneradoId"
                      margin
                      required
                    >
                      <SelectInsumosItem
                        empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                        headersToken={this.props.headersToken}
                        sinBorde
                        autoFocus
                        disabled
                        dropdownMatchSelectWidth={600}
                        width="100%"
                        placeholder="Insumo a Generar"
                        tiposInsumos="inventariables"
                        onChange={(value, insumoEncontrado) => { this.onChangeInsumoGenerar(value, insumoEncontrado) }}
                      />
                    </FormItem>
                  </Col>
                  <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                    <FormItem
                      label="Cantidad a Generar"
                      name="cantidadGenerada"
                      number
                      disabled
                      required
                      type="number"
                    >
                      <InputNumberItem onChange={this.onChangeCantidad.bind(this)} />
                    </FormItem>
                  </Col>
                  <Col span={8} xs={24} sm={24} lg={8} xl={8}>
                    <FormItem
                      noStyle
                      shouldUpdate
                    >
                      {({ getFieldValue }) => {
                        let insumoGeneradoId = getFieldValue("insumoGeneradoId");
                        let mostrarMarbetes = false
                        let mostrarLotes = false
                        let mostrarVehiculo = false
                        let insumo = null; 
                        if (insumoGeneradoId) {
                          insumo = this.state.todasInsumos.find(
                            (valueInsumos) => valueInsumos._id === insumoGeneradoId
                          );
                          mostrarMarbetes = insumo?.marbetes
                          mostrarLotes = insumo?.lotesCaducidades
                          mostrarVehiculo = insumo?.vehiculo
                        }
                        if (mostrarMarbetes) {
                          return (
                            <ButtonItem
                              type="primary"
                              size='small'
                              block
                              onClick={() => {
                                const insumoId = insumo?._id
                                this.abrirAgregarMarbetes(this.state.modalAgregarMarbetesMarbetes, insumoId)
                              }}
                            >
                              Marbetes
                            </ButtonItem>
                          )
                        }
                        if (mostrarLotes) {
                          return (
                            <ButtonItem
                              type="primary"
                              size='small'
                              block
                              onClick={() => {
                                this.abrirAgregarLotes(mostrarVehiculo, this.state.modalAgregarLotesLotes)
                              }}
                            >
                              {this.props.taxidermia ? 'Animales' : 'Lotes'}
                            </ButtonItem>
                          )
                        }
                      }}
                    </FormItem>
                  </Col>
                </Row>
                <Divider
                  style={{ marginBottom: 10, marginTop: 5 }}
                  children="Proyecto"
                />
                <Row>
                  <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                    <FormItem shouldUpdate noStyle>
                      {({ getFieldValue }) => {
                        const insumosUtilizados =
                          getFieldValue("insumosUtilizados");
                        const disabled = insumosUtilizados?.length > 0;
                        return (
                          <FormItem
                            label="Proyecto"
                            name="proyectoId"
                            margin
                            required
                          >
                            <SelectItem
                              placeholder="Proyecto"
                              disabled={disabled}
                            >
                              {this.state.objetoProyectos}
                            </SelectItem>
                          </FormItem>
                        );
                      }}
                    </FormItem>
                  </Col>
                  <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                    <FormItem
                      label="Fecha de Produccion"
                      name="fechaProduccion"
                      required
                      margin
                      initialValue={moment()}
                    >
                      <DatePickerItem
                        placeholder="Fecha de Produccion"
                        allowClear={false}
                      />
                    </FormItem>
                  </Col>
                </Row>
                <Divider
                  style={{ marginBottom: 10, marginTop: 5 }}
                  children="Insumos a Utilizar"
                />
                <FormInitial.List name="insumosUtilizados">
                  {(fields, { add, remove }) => (
                    <>
                      <div style={{ overflowX: 'auto' }}>
                        <table className="table" style={{ minWidth: isMobile ? "900px" : "100%" }}>
                          {fields.length > 0 ? (
                            <thead>
                              <tr>
                                <th
                                  className="th-border"
                                  style={{ width: "50%" }}
                                >
                                  Insumo
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "20%" }}
                                >
                                  Cantidad Proyecto
                                </th>
                                <th
                                  className="th-border"
                                  style={{ width: "20%" }}
                                >
                                  Cantidad
                                </th>
                                <th className="th-border" style={{ width: '10%' }}>Accion</th>
                              </tr>
                            </thead>
                          ) : null}
                          {fields.map(
                            ({ key, name, fieldKey, ...restField }, arrayKey) => (
                              <tbody>
                                <tr>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "insumoId"]}
                                      fieldKey={[arrayKey, "insumoId"]}
                                      required
                                      noStyle
                                    >
                                      <SelectInsumosItem
                                        empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                        headersToken={this.props.headersToken}
                                        sinBorde
                                        autoFocus
                                        disabled
                                        dropdownMatchSelectWidth={600}
                                        width="100%"
                                        placeholder="Insumo"
                                        tiposInsumos="inventariables"
                                        onChange={(value, insumoEncontrado) =>
                                          this.onChangeInsumo(
                                            value,
                                            arrayKey,
                                            insumoEncontrado
                                          )
                                        }
                                      />
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      {...restField}
                                      name={[name, "cantidadProyecto"]}
                                      fieldKey={[arrayKey, "cantidadProyecto"]}
                                      number
                                      noStyle
                                      required
                                      initialValue={undefined}
                                    >
                                      <InputNumberItem sinBorde disabled />
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <FormItem
                                      noStyle
                                      shouldUpdate={(prev, curr) =>
                                        prev.insumosUtilizados[arrayKey]
                                          ?.cantidadProyecto !==
                                        curr.insumosUtilizados[arrayKey]
                                          ?.cantidadProyecto
                                      }
                                    >
                                      {({ getFieldValue }) => {
                                        const insumosUtilizados =
                                          getFieldValue("insumosUtilizados");
                                        if (!insumosUtilizados[arrayKey]) return;
                                        const cantidadProyecto =
                                          insumosUtilizados[arrayKey]
                                            .cantidadProyecto;
                                        let max = cantidadProyecto;
                                        return (
                                          <FormItem
                                            {...restField}
                                            name={[name, "cantidad"]}
                                            fieldKey={[arrayKey, "cantidad"]}
                                            number
                                            noStyle
                                            required
                                            max={max}
                                            type="number"
                                            initialValue={undefined}
                                          >
                                            <InputNumberItem sinBorde disabled />
                                          </FormItem>
                                        );
                                      }}
                                    </FormItem>
                                  </td>
                                  <td className="td-border">
                                    <Row>
                                      <Col span={24}>
                                        <FormItem
                                          noStyle
                                          shouldUpdate
                                        >
                                          {({ getFieldValue }) => {
                                            let arrayValue = getFieldValue("insumosUtilizados");
                                            const proyectoId = getFieldValue("proyectoId");
                                            let mostrarMarbetes = false
                                            let mostrarLotes = false
                                            let insumoId
                                            if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                              const insumo = this.state.todasInsumos.find(
                                                (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                              );
                                              mostrarMarbetes = insumo?.marbetes
                                              mostrarLotes = insumo?.lotesCaducidades
                                              insumoId = insumo?._id
                                            }
                                            if (mostrarMarbetes) {
                                              return (
                                                <ButtonItem
                                                  type="primary"
                                                  size='small'
                                                  block
                                                  onClick={() => {
                                                    this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId)
                                                  }}
                                                >
                                                  Marbetes
                                                </ButtonItem>
                                              )
                                            } else if (mostrarLotes) {
                                              return (
                                                <ButtonItem
                                                  type="primary"
                                                  size='small'
                                                  style={{ width: '80%', marginLeft: '10%' }}
                                                  block
                                                  onClick={() => {
                                                    this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].cantidad)
                                                  }}
                                                >
                                                  {this.props.taxidermia ? "Animales" : "Lotes"}
                                                </ButtonItem>
                                              )
                                            }
                                          }}
                                        </FormItem>
                                      </Col>
                                    </Row>
                                  </td>
                                </tr>
                              </tbody>
                            )
                          )}
                        </table>
                      </div>
                    </>
                  )}
                </FormInitial.List>
              </Form>
            ) : (
              <Form
                ref={this.formRefPrimerForm}
                layout
                bottom={
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Siguiente
                  </ButtonItem>
                }
                onFinish={this.onFinishPrimerForm.bind(this)}
                onFinishFailed={this.onFinishFailed}
              >
                <Row>
                  <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                    <FormItem
                      label="Lista De Materiales"
                      name="listaDeMaterialesId"
                      margin
                      required
                    >
                      <SelectItem placeholder="Lista De Materiales">
                        {this.state.objetoListaDeMateriales}
                      </SelectItem>
                    </FormItem>
                  </Col>
                  <Col span={12} xs={24} sm={24} lg={12} xl={12}>
                    <FormItem
                      label="Proyecto"
                      name="proyectoId"
                      margin
                      required
                    >
                      <SelectItem placeholder="Proyecto">
                        {this.state.objetoProyectos}
                      </SelectItem>
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            )}
          </Spin>
        </div>
        <VistaPrevia
          visible={this.state.modalVistaPrevia}
          id={this.state.modalVistaPreviaId}
          cerrarVistaPrevia={this.cerrarVistaPrevia.bind(this)}
        />
        <AgregarLotes
          visible={this.state.modalAgregarLotes}
          cerrarAgregarLotes={this.cerrarAgregarLotes.bind(this)}
          lotes={this.state.modalAgregarLotesLotes}
          vehiculo={this.state.modalAgregarLotesVehiculo}
          insumoId = { this.state.modalAgregarLotesInsumoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          cantidad={this.state.modalElegirLotesCantidad}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(AgregarOrdenDeProduccion);
